export default {
    setCharities (state, { charities }) {
        state.charities = charities
    },
    setCharity (state, { charity }) {
        state.charity = charity
    },
    setSelectedCharity (state, { charity }) {
        state.selectedCharity = charity
    }
}



// WEBPACK FOOTER //
// ./src/store/charities/mutations.js